import { initContract } from '@ts-rest/core';
import { adminDrawContract } from './draw.admin.contract';
import { authDrawContract } from './draw.auth.contract';
import { publicDrawContract } from './draw.public.contract';

const c = initContract();

export const drawContract = c.router(
  {
    admin: adminDrawContract,
    auth: authDrawContract,
    public: publicDrawContract,
  },
  {
    pathPrefix: '/draw/draw',
    strictStatusCodes: true,
  }
);

export * from './draw.admin.contract';
export * from './draw.auth.contract';
export * from './draw.public.contract';
export * from './models';

